import {
  WSFlexBox,
  WSIcon,
  WSTableCellProps,
  WSText
} from "@wingspanhq/fe-component-library";

export const LabelRequirementType: React.FC<WSTableCellProps> = props => (
  <WSFlexBox gap="XS" wrap="nowrap" alignItems="center">
    {props.icon && <WSIcon name={props.icon} color="gray600" size="S" />}
    <WSText.ParagraphXs color="gray600">{props.text}</WSText.ParagraphXs>
  </WSFlexBox>
);
